import { Component, Fragment } from 'react';
import { Api } from '../../api';
import {
  getMonthsNameMap,
  getYearMonthRange,
} from '../../constants/dashboard/monthlyStatement';
import { trackAction } from '../../utils/trackActions';

// Running yead and month
const DATE_INFO = new Date().toISOString().slice(0, 7);
const YEAR: string = DATE_INFO.slice(0, 4);
const MONTH: string = DATE_INFO.slice(5, 7);
const PREDECESSOR_MONTH: string =
  MONTH === '01'
    ? '12'
    : Number(MONTH) - 1 < 10
    ? '0' + (Number(MONTH) - 1).toString()
    : (Number(MONTH) - 1).toString();
const SELECTED_YEAR: string =
  MONTH === '01' ? (Number(YEAR) - 1).toString() : YEAR;
const MAP_NO_TO_MONTH = getMonthsNameMap(SELECTED_YEAR);

const api = new Api();

interface State {
  startDate: string;
  endDate: string;
  selected: string;
  monthYearList: any[];
}

class MonthlyStatement extends Component<any, State> {
  constructor(props: State) {
    super(props);
    const lastDateOfMonth = this.getDaysForMonth(
      SELECTED_YEAR,
      PREDECESSOR_MONTH
    );
    this.state = {
      startDate: `${SELECTED_YEAR}-${PREDECESSOR_MONTH}-01`,
      endDate: `${SELECTED_YEAR}-${PREDECESSOR_MONTH}-${lastDateOfMonth}`,
      selected: `${SELECTED_YEAR}-${PREDECESSOR_MONTH}`,
      monthYearList: [],
    };
  }

  public componentDidMount() {
    const {
      userInfo: { firstInvestmentDate },
    } = this.props;
    const list = !!firstInvestmentDate
      ? getYearMonthRange(firstInvestmentDate)
      : [];

    /* Black-2587, as per new req from Product, we have to show investment details of current month also, removing this pop
    list.pop(); // remove current month from list
    */
    this.setState({
      monthYearList: list,
    });
  }

  public getDaysForMonth = (year: string, month: string) => {
    return new Date(Number(year), Number(month), 0).getDate();
  };

  public handleDropdown = (e: any) => {
    const { value } = e.target;
    const year = value.slice(0, 4);
    const month = value.slice(5, 7);
    const lastDateOfMonth = this.getDaysForMonth(year, month);
    this.setState({
      startDate: `${value}-01`,
      endDate: `${value}-${lastDateOfMonth}`,
      selected: `${year}-${month}`,
    });
  };

  public downloadMI = (e: any) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const { startDate, endDate } = this.state;
    const statementDownloadMonth = MAP_NO_TO_MONTH[startDate.slice(5, 7)];
    trackAction(
      'download-monthly-statement',
      'monthly-statement',
      `${statementDownloadMonth}`
    );
    api.downloadMonthlyStatement(startDate, endDate);
  };

  public render() {
    const { selected, monthYearList } = this.state;
    const { downloadElssProof, elssInvestmentYears } = this.props;
    if (!monthYearList.length) {
      return null;
    }
    return (
      <Fragment>
        <div className="ms-container mt30">
          <div className="download-report-heading">REPORTS</div>
          <div className="download-monthly-container">
            <div className="font--dark-gray mb10">Monthly Statement</div>
            <select
              onChange={this.handleDropdown}
              className="dropdown text--normal mb30"
              value={selected}
            >
              {monthYearList.map(item => {
                return (
                  <option key={item.id} value={item.value}>
                    {item.label}
                  </option>
                );
              })}
            </select>
            <div
              className="font--bold font--md  font--blue downloadButton"
              onClick={this.downloadMI}
            >
              Download
            </div>
          </div>
          <div className="download-elss-container">
            <div className="elss-dowload-heading">ELSS Tax Proof (80C)</div>
            {elssInvestmentYears && !elssInvestmentYears.length ? null : (
              <div
                className="font--bold font--md  font--blue downloadButton"
                onClick={downloadElssProof}
              >
                Download
              </div>
            )}
          </div>

          <style jsx>{`
            .dropdown {
              // box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);
              z-index: 1;
              text-align: left;
              width: 100%;
              background-color: #efefef;
              padding: 5px !important;
            }
            .dropdown option {
              padding: 5px !important;
            }
            .ms-container {
              border: 1px solid #ddd;
              width: 189px;
            }
            .download-report-heading {
              font-family: Source Sans Pro;
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 18px;
              color: #333333;
              border-bottom: 1px solid #ddd;
              padding: 15px;
            }
            .download-monthly-container {
              padding: 15px;
              border-bottom: 1px solid #ddd;
            }
            .download-elss-container {
              padding: 15px;
            }
            .elss-dowload-heading {
              font-family: Source Sans Pro;
              font-style: normal;
              font-weight: normal;
              font-size: 16px;
              line-height: 18px;
              color: #666666;
              margin-bottom: 10px;
            }
            .downloadButton {
              display: inline-block;
              cursor: pointer;
            }
          `}</style>
        </div>
      </Fragment>
    );
  }
}
export default MonthlyStatement;



// WEBPACK FOOTER //
// ./components/dashboard/monthlyStatement.tsx